import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import {
  fetchContenidosDinamicos,
  fetchImagenes,
  fetchImage,
  getUltimaActualizacion,
  fetchCategoriaNombreImagen,
  uploadImage,
  cambiarOrdenComentariosImagenes,
  cambiarComentariosImagenesSeleccion,
  cambiarUsarOrden,
  borrarImagenes,
  fetchOpcionesRotacion,
  rotacionImagenes,
  deleteImage,
  updateImage,
  generarZipImagenesContenidoDinamico,
  generarZipImagenes,
  fetchVideos,
  fetchVideosFase,
  deleteVideo,
  uploadVideo,
} from "../../components/functions/Projects";
import {
  Tabs,
  Tab,
  Dialog,
  IconButton,
  Box,
  Typography,
  Paper,
  Stack,
  Button,
  Chip,
  Switch,
  FormGroup,
  FormControlLabel,
  Popper,
  Snackbar,
} from "@mui/material";
import "./Modal.css";
import CloseIcon from "@mui/icons-material/Close";
import Dropzone from "react-dropzone";
import DeleteIcon from "@mui/icons-material/Delete";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import Ajustes from "../../assets/img/svg/users/opciones.svg";
import Editar from "../../assets/img/svg/users/editar.svg";
import Eliminar from "../../assets/img/svg/users/eliminar.svg";
import EliminarBlanco from "../../assets/img/svg/users/eliminarBlanco.svg";
import DescargarBlanco from "../../assets/img/svg/users/descargarBlanco.svg";
import Comentarios from "../../assets/img/svg/users/comentarios.svg";
import DownloadIcon from "@mui/icons-material/Download";
import useEmblaCarousel from "embla-carousel-react";
import Rotate90DegreesCcwIcon from "@mui/icons-material/Rotate90DegreesCcw";
import Rotate90DegreesCwIcon from "@mui/icons-material/Rotate90DegreesCw";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import RestoreIcon from "@mui/icons-material/Restore";
import SaveIcon from "@mui/icons-material/Save";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import LoaderDialog from "../../ui/loader/Loader";
import DocumentosTab from "./components/DocumentosTab";
import ImageEditor from "./components/ImageEditor";
import CustomButton from "../../ui/button/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Select from "react-select";
import DropdownCaret from "../../ui/select/DropDown";

export const ImagenesModal = ({
  API_URL,
  showModal,
  handleCloseModal = () => {},
  trabajoId,
  trabajoName,
  trabajo = null,
  timestamp,
  user,
}) => {
  const [contenidosDinamicos, setContenidosDinamicos] = useState([]);
  const [imagenes, setImagenes] = useState([]);
  const [selectedContenidoDinamico, setSelectedContenidoDinamico] =
    useState(null);
  const [selectedType, setSelectedType] = useState(1);
  const [ultimaActualizacion, setUltimaActualizacion] = useState("");
  const [imagenesCategorias, setImagenesCategorias] = useState([]);
  const [showCategoriaModal, setShowCategoriaModal] = useState(false);
  const [showOrdenModal, setShowOrdenModal] = useState(false);
  const [usarOrdenAutomatico, setUsarOrdenAutomatico] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmModalType, setConfirmModalType] = useState("");
  const [showRotateImageModal, setShowRotateImageModal] = useState(false);
  const [opcionesRotacion, setOpcionesRotacion] = useState([]);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedCarouselIndex, setSelectedCarouselIndex] = useState(0);
  const [showRotateImageCarousel, setShowRotateImageCarousel] = useState(false);
  const [videos, setVideos] = useState([]);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [rotation, setRotation] = useState(0);
  const [showLoader, setShowLoader] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  // const [trackerData, setTrackerData] = useState(null);
  // const [openStepperModal, setOpenStepperModal] = useState(false);
  const [rowSelection, setRowSelection] = useState({});

  const editorRef = useRef(null);
  const videoRefs = useRef({});
  const carouselRef = useRef(null);

  const pathToSplit = `/${process.env.REACT_APP_CHECK_PATH}/`;

  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    watchDrag: false,
    duration: 0,
    startIndex: selectedCarouselIndex,
  });

  const notify = (msg) => {
    setShowSnackbar(true);
    setSnackbarMessage(msg || "");
  };

  /* const handleUpdateEvent = async (estatus, reason, details) => {
    let pm = trabajo?.proyecto?.usuarioPM;
    let usuarioPM =
      typeof pm === "object" ? pm : typeof pm === "number" ? { id: pm } : null;

    await updateTrackerEvent(
      API_URL,
      trabajoId,
      6,
      estatus,
      estatus === "error" ? reason : details,
      user.id,
      trabajoName,
      usuarioPM,
      user.nombre,
      user.correo
    );
    if (estatus === "completado") {
      setTrackerData(null);
    }
  }; */

  const openFromURL = async (url, id) => {
    const queryParams = url.split("?")[1];

    const { buffer, contentType, filename } = await fetchImage(
      API_URL,
      queryParams
    );

    const type = contentType === "image/jpg" ? "image/jpeg" : contentType;
    const blob = new Blob([buffer], { type });
    const file = new File([blob], filename, { type });
    editorRef.current?.openWithFile(
      file,
      true,
      imagenes.find((img) => img.id === id)
    );
  };

  const rotate = (angle) => {
    setRotation((prev) => prev + angle);
  };

  const handleRotationModalClose = () => {
    setShowRotateImageCarousel(false);
    setRotation(0);
    setSelectedCarouselIndex(0);
  };

  const resetRotation = () => {
    setRotation(0);
  };

  const fetchTotalVideos = async () => {
    const resVideos = await fetchVideos(API_URL, trabajoId);
    setVideos(resVideos);
  };

  /* const hasSelection = useMemo(
    () => Object.keys(rowSelection).length > 0,
    [rowSelection]
  ); */

  const selectStyles = (maxMenuHeight) => ({
    container: (base) => ({ ...base, width: "100%" }),

    control: (base, state) => ({
      ...base,
      border: "1px solid",
      borderColor: state.isFocused ? "#ccc" : "#ccc", // sin azul al focus
      borderRadius: 4,
      minHeight: 50,
      width: "100%",
      fontSize: 16,
      color: "#555",
      boxShadow: "none", // ← sin halo/sombra al enfocar
      backgroundColor: "white",
      "&:hover": {
        borderColor: "#999", // hover gris, no azul
      },
    }),

    valueContainer: (base) => ({ ...base, padding: "0 8px" }),
    placeholder: (base) => ({ ...base, color: "#555", fontSize: 16 }),
    singleValue: (base) => ({ ...base, color: "#555", fontSize: 16 }),

    // Flecha sin azul
    dropdownIndicator: (base) => ({
      ...base,
      color: "#555",
      paddingRight: 8,
      ":hover": { color: "#555" },
    }),
    indicatorSeparator: () => ({ display: "none" }),
    clearIndicator: () => ({ display: "none" }),

    menuPortal: (base) => ({ ...base, zIndex: 2000 }),
    menu: (base) => ({
      ...base,
      zIndex: 2000,
      border: "1px solid #ccc",
      borderRadius: 4,
      overflow: "hidden",
    }),
    option: (base, state) => ({
      ...base,
      fontSize: 14,
      color: "#333",
      backgroundColor: state.isSelected
        ? "#e0e0e0"
        : state.isFocused
        ? "#f5f5f5"
        : "white",
      cursor: "pointer",
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: maxMenuHeight,
      overflowY: "auto",
    }),
  });

  const CustomDot = ({ onClick, ...rest }) => {
    const { active } = rest;

    return (
      <li
        onClick={onClick}
        style={{
          display: "inline-block",
          margin: "0 6px",
          cursor: "pointer",
          width: active ? "12px" : "12px",
          height: active ? "12px" : "12px",
          borderRadius: "50%",
          border: "1px solid rgba(255, 255, 255, 0.5)",
          backgroundColor: active
            ? "rgba(255, 255, 255, 0.9)"
            : "rgba(255, 255, 255, 0.4)",
          opacity: 0.8,
          transition: "all 0.3s ease",
          boxShadow: active ? "0 0 6px rgba(0,0,0,0.3)" : "none",
        }}
      />
    );
  };

  const ButtonGroup = () => {
    return (
      <div className="carousel-button-group">
        <Button
          sx={{
            textTransform: "none",
            right: 10,
            top: 10,
            position: "absolute",
            px: "8px",
            py: "4px",
          }}
          variant="contained"
          color="error"
          startIcon={<DeleteIcon />}
          onClick={() => {
            setShowConfirmModal(true);
            setConfirmModalType("deleteVideo");
          }}
        >
          Borrar video
        </Button>
      </div>
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      const resContenidos = await fetchContenidosDinamicos(API_URL, trabajoId);
      resContenidos.forEach((fase) => {
        if (fase.descripcion === "Entregable") {
          fase.descripcion = "Implementación";
        }
      });
      setContenidosDinamicos(resContenidos || []);
      if (resContenidos.length > 0) {
        setSelectedContenidoDinamico(resContenidos[0]);
      }
    };
    if (trabajoId && showModal) {
      fetchData();
    }
  }, [trabajoId, timestamp, showModal]);

  useEffect(() => {
    videos.forEach((video) => {
      if (!videoRefs.current[video.id]) {
        videoRefs.current[video.id] = React.createRef();
      }
    });
  }, [videos]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selectedType === 1) {
          const [
            resImagenes,
            resActualizacion,
            resImagenesCategorias,
            resOpcionesRotacion,
          ] = await Promise.all([
            fetchImagenes(API_URL, selectedContenidoDinamico?.id),
            getUltimaActualizacion(API_URL, trabajoId, "IMAGENES"),
            fetchCategoriaNombreImagen(
              API_URL,
              trabajo?.tipoTrabajo?.id,
              selectedContenidoDinamico?.fase
            ),
            fetchOpcionesRotacion(API_URL),
          ]);

          setUltimaActualizacion(resActualizacion.respuesta);
          setImagenes(resImagenes || []);
          setImagenesCategorias(resImagenesCategorias || []);
          setOpcionesRotacion(resOpcionesRotacion);
        } else if (selectedType === 2) {
        } else if (selectedType === 3) {
          if (carouselRef.current) {
            carouselRef.current.goToSlide(0);
          }
          const resVideos = await fetchVideosFase(
            API_URL,
            selectedContenidoDinamico?.id
          );
          setVideos(resVideos);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (selectedContenidoDinamico && showModal) {
      fetchData();
    }
  }, [selectedContenidoDinamico, selectedType, timestamp, showModal]);

  const columns = [
    { accessorKey: "id", header: "ID", size: 10 },
    {
      accessorKey: "fecha",
      header: "Fecha",
      size: 50,
      accessorFn: (row) => `${new Date(row.fecha).toLocaleDateString("es-MX")}`,
    },
    { accessorKey: "subidoPor", header: "Subido por", size: 80 },
    {
      accessorKey: "comentarios",
      header: "Comentarios",
      size: 200,
      Cell: ({ cell }) => {
        const rowId = cell.row.original.id;
        const valorActual = cell.row.original.comentarios || "";
        const wrapperRef = useRef(null);

        const [menuPlacement, setMenuPlacement] = useState("auto");
        const [maxMenuHeight, setMaxMenuHeight] = useState(300);
        const [isOpen, setIsOpen] = useState(false);

        const SAFE_PADDING = 8; // margen de seguridad a borde de viewport
        const MIN_MENU = 140; // alto mínimo razonable del menú

        const options = useMemo(
          () => [
            { value: "", label: "Sin comentarios" },
            ...imagenesCategorias.map((img) => ({
              value: img.nombre,
              label: img.nombre,
            })),
          ],
          [imagenesCategorias]
        );

        const valueObj =
          options.find((o) => o.value === valorActual) || options[0];

        const recomputePlacement = useCallback(() => {
          if (!wrapperRef.current) return;
          const rect = wrapperRef.current.getBoundingClientRect();
          const vh = typeof window !== "undefined" ? window.innerHeight : 800;

          const spaceAbove = Math.max(0, rect.top - SAFE_PADDING);
          const spaceBelow = Math.max(0, vh - rect.bottom - SAFE_PADDING);

          // Elige el lado con más espacio
          if (spaceAbove > spaceBelow) {
            setMenuPlacement("top");
            setMaxMenuHeight(Math.max(MIN_MENU, Math.floor(spaceAbove)));
          } else {
            setMenuPlacement("bottom");
            setMaxMenuHeight(Math.max(MIN_MENU, Math.floor(spaceBelow)));
          }
        }, []);

        // Recalcular al abrir el menú
        const handleOpen = useCallback(() => {
          setIsOpen(true);
          recomputePlacement();
        }, [recomputePlacement]);

        const handleClose = useCallback(() => setIsOpen(false), []);

        // Recalcular si hay resize o scroll mientras el menú está abierto
        useEffect(() => {
          if (!isOpen) return;
          const onEvt = () => recomputePlacement();
          window.addEventListener("resize", onEvt);
          window.addEventListener("scroll", onEvt, true); // true para capturar scrolls en contenedores
          return () => {
            window.removeEventListener("resize", onEvt);
            window.removeEventListener("scroll", onEvt, true);
          };
        }, [isOpen, recomputePlacement]);

        return (
          <div
            ref={wrapperRef}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
            onTouchStart={(e) => e.stopPropagation()}
            style={{ width: "100%" }}
          >
            <Select
              options={options}
              value={valueObj}
              onChange={(opt) => {
                const imagen = imagenes.find((i) => i.id === rowId);
                if (imagen) imagen.comentarios = opt?.value || "";
                setImagenes([...imagenes]);
              }}
              placeholder="Sin comentarios"
              components={{ DropdownIndicator: DropdownCaret }}
              menuPlacement={menuPlacement}
              maxMenuHeight={maxMenuHeight}
              menuPortalTarget={
                typeof window !== "undefined" ? document.body : null
              }
              menuPosition="fixed"
              menuShouldScrollIntoView={false}
              onMenuOpen={handleOpen}
              onMenuClose={handleClose}
              styles={selectStyles(maxMenuHeight)}
              isClearable
            />
          </div>
        );
      },
    },
    {
      accessorKey: "link",
      header: "Imagen",
      size: 80,
      Cell: ({ cell }) => {
        return (
          <Box
            component="img"
            src={`${API_URL}/${
              cell.row.original.thumbLink.split(pathToSplit)[1]
            }`}
            alt={cell.row.original.comentarios}
            sx={{
              maxHeight: "140px",
              maxWidth: "140px",
              objectFit: "contain",
              justifySelf: "center",
              borderRadius: "6px",
              cursor: "pointer",
              "&:hover": {
                transform: "scale(1.05)",
              },
              transition: "all 0.2s ease-in-out",
            }}
          />
        );
      },
    },
    {
      accessorKey: "acciones",
      header: "Acciones",
      size: 40,
      Cell: ({ row }) => {
        const rowData = row.original;
        const anchorRef = useRef(null);
        const isOpen = openMenuIndex === row.index;

        return (
          <div
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <button
              ref={anchorRef}
              onClick={(e) => {
                e.stopPropagation();
                setOpenMenuIndex((prevIndex) =>
                  prevIndex === row.index ? null : row.index
                );
              }}
              className="action-icon"
            >
              <img
                src={Ajustes}
                alt="Ajustes"
                style={{ width: "20px", height: "20px" }}
              />
            </button>

            <Popper
              open={isOpen}
              anchorEl={anchorRef.current}
              placement="bottom-start"
              style={{ zIndex: 9999 }}
              onClick={(e) => e.stopPropagation()}
            >
              <ClickAwayListener onClickAway={() => setOpenMenuIndex(null)}>
                <div
                  className="dropdown-menu-user"
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    marginTop: "5px",
                    padding: "5px",
                    minWidth: "150px",
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <p
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 10px",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      const image = imagenes.find(
                        (imagen) => imagen.id === rowData.id
                      );
                      if (image) {
                        image.saltarPagina = !image.saltarPagina;
                        setImagenes([...imagenes]);
                      }
                    }}
                  >
                    <img
                      src={Editar}
                      alt=""
                      style={{
                        width: "16px",
                        height: "16px",
                        marginRight: "8px",
                      }}
                    />
                    {rowData.saltarPagina
                      ? "Desactivar salto de página"
                      : "Activar salto de página"}
                  </p>
                  <p
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 10px",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedId(rowData.id);
                      setShowEditModal(true);
                      setOpenMenuIndex(null);
                    }}
                  >
                    <img
                      src={Editar}
                      alt=""
                      style={{
                        width: "16px",
                        height: "16px",
                        marginRight: "8px",
                      }}
                    />
                    Editar Imagen
                  </p>
                  <p
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 10px",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowConfirmModal(true);
                      setConfirmModalType("deleteOne");
                      setOpenMenuIndex(null);
                      setSelectedId(rowData.id);
                    }}
                  >
                    <img
                      src={Eliminar}
                      alt=""
                      style={{
                        width: "16px",
                        height: "16px",
                        marginRight: "8px",
                      }}
                    />
                    Eliminar Imagen
                  </p>
                </div>
              </ClickAwayListener>
            </Popper>
          </div>
        );
      },
    },
  ];

  const table = useMaterialReactTable({
    autoResetPageIndex: false,
    columns,
    data: imagenes,
    enableRowSelection: true,
    enableRowOrdering: true,
    enableSorting: false,
    enableFilters: false,
    enableTopToolbar: false,
    enableColumnActions: false,
    getRowId: (originalRow) => originalRow.id,
    positionToolbarAlertBanner: "none",
    localization: MRT_Localization_ES,
    layoutMode: "grid",
    defaultColumn: {
      minSize: 40,
      size: 80,
    },
    onRowSelectionChange: setRowSelection,
    state: { rowSelection },
    muiRowDragHandleProps: ({ table }) => ({
      onDragEnd: () => {
        const { draggingRow, hoveredRow } = table.getState();
        if (hoveredRow && draggingRow) {
          imagenes.splice(
            hoveredRow.index,
            0,
            imagenes.splice(draggingRow.index, 1)[0]
          );
          setImagenes([...imagenes]);
        }
      },
    }),
    muiTableBodyRowProps: ({ row }) => ({
      onClick: (event) => {
        setSelectedId(row.original.id);
        openFromURL(
          `${API_URL}/${row.original.link.split(pathToSplit)[1]}`,
          row.original.id
        );
      },
      sx: {
        cursor: "pointer",
      },
    }),
  });

  const scrollPrev = useCallback(() => {
    resetRotation();
    if (emblaApi) emblaApi.scrollPrev();
    setSelectedCarouselIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    resetRotation();
    if (emblaApi) emblaApi.scrollNext();
    setSelectedCarouselIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  const handleDeleteVideo = async () => {
    try {
      setShowLoader(true);
      await deleteVideo(API_URL, videos[currentVideoIndex].id);
      const newVideos = videos.filter(
        (video) => video.id !== videos[currentVideoIndex].id
      );
      setVideos(newVideos);
      setShowLoader(false);
      notify("Video borrado con éxito");
    } catch (error) {
      setShowLoader(false);
    }
  };

  const handleUploadVideo = async (file) => {
    if (!file) {
      notify("Por favor, selecciona un video válido.");
      return;
    }
    try {
      setShowLoader(true);
      await uploadVideo(API_URL, file, selectedContenidoDinamico?.id);
      const videosRes = await fetchVideosFase(
        API_URL,
        selectedContenidoDinamico?.id
      );
      setVideos(videosRes);
      setShowLoader(false);
      notify("Video subido con éxito");
    } catch (error) {
      setShowLoader(false);
      console.error("Error uploading video:", error);
    }
  };

  async function subirImagen(file, selectedCategoria = null) {
    if (!file) {
      notify("Por favor, selecciona una imagen válida.");
      return;
    }
    try {
      setShowLoader(true);
      await uploadImage(
        API_URL,
        file,
        selectedContenidoDinamico?.id,
        selectedCategoria?.nombre || undefined
      );
      const resImagenes = await fetchImagenes(
        API_URL,
        selectedContenidoDinamico?.id
      );

      setImagenes(resImagenes || []);
      setShowLoader(false);
      notify("Imagen subida con éxito");
    } catch (error) {
      setShowLoader(false);
    }
  }

  async function subirMultiplesImagenes(files, selectedCategoria = null) {
    if (!files || files.length === 0) {
      notify("Por favor, selecciona imágenes válidas.");
      return;
    }
    try {
      setShowLoader(true);
      await Promise.all(
        files.map(async (file) => {
          await uploadImage(
            API_URL,
            file,
            selectedContenidoDinamico?.id,
            selectedCategoria?.nombre || undefined
          );
        })
      );

      const resImagenes = await fetchImagenes(
        API_URL,
        selectedContenidoDinamico?.id
      );

      setImagenes(resImagenes || []);
      setShowLoader(false);
      notify("Imágenes subidas con éxito");
    } catch (error) {
      notify("Error al subir las imágenes");
      setShowLoader(false);
    }
  }

  async function handleUploadMultipleVideos(files) {
    if (!files || files.length === 0) {
      notify("Por favor, selecciona videos válidos.");
      return;
    }
    try {
      setShowLoader(true);
      await Promise.all(
        files.map(async (file) => {
          await uploadVideo(API_URL, file, selectedContenidoDinamico?.id);
        })
      );

      const videosRes = await fetchVideosFase(
        API_URL,
        selectedContenidoDinamico?.id
      );
      setVideos(videosRes);
      setShowLoader(false);
      notify("Videos subidos con éxito");
    } catch (error) {
      setShowLoader(false);
      notify("Error al subir los videos");
    }
  }

  async function guardarCambios() {
    try {
      setShowLoader(true);
      const imagenesFormateadas = imagenes.map((imagen, index) => {
        return {
          ...imagen,
          orden: index + 1,
        };
      });
      await cambiarOrdenComentariosImagenes(API_URL, imagenesFormateadas);
      setShowLoader(false);
      notify("Cambios guardados con éxito");
    } catch (error) {
      setShowLoader(false);
    }
  }

  const getSelectedRows = () => {
    const selectedRows = table.getSelectedRowModel().flatRows.map((row) => {
      return row.original;
    });
    return selectedRows;
  };

  const cambiarComentariosPorSeleccion = async (categoriaId) => {
    const selectedRows = getSelectedRows();
    if (selectedRows.length === 0) {
      return;
    }

    try {
      setShowLoader(true);
      await cambiarComentariosImagenesSeleccion(
        API_URL,
        selectedRows,
        categoriaId
      );

      for (const row of selectedRows) {
        const imagen = imagenes.find((imagen) => {
          return imagen.id === row.id;
        });
        if (imagen) {
          imagen.comentarios = imagenesCategorias.find(
            (categoria) => categoria.id == categoriaId
          )?.nombre;
        }
      }
      setImagenes([...imagenes]);
      setShowLoader(false);
      notify("Cambios guardados con éxito");
    } catch (error) {
      setShowLoader(false);
    }
  };

  const openCategoriaModal = async () => {
    const selectedRows = getSelectedRows();
    if (selectedRows.length === 0) {
      return;
    }
    setShowCategoriaModal(true);
  };

  const handleCambiarOrdenamiento = async () => {
    try {
      setShowLoader(true);
      const checked = !usarOrdenAutomatico;
      await cambiarUsarOrden(API_URL, selectedContenidoDinamico.id, checked);
      const contenido = contenidosDinamicos.find(
        (contenido) => contenido.id == selectedContenidoDinamico.id
      );
      contenido.usarOrdenAutomatico = checked;
      setContenidosDinamicos([...contenidosDinamicos]);
      setSelectedContenidoDinamico(contenido);
      setUsarOrdenAutomatico(checked);
      setShowLoader(false);
      notify("Cambios guardados con éxito");
    } catch (error) {
      setShowLoader(false);
    }
  };

  const cerrarYLimpiarTodo = () => {
    handleCloseModal();
    setImagenes([]);
    setVideos([]);
    setSelectedId(null);
    setSelectedCarouselIndex(null);
    setSelectedContenidoDinamico(null);
    setSelectedType(1);
    setShowCategoriaModal(false);
    setShowOrdenModal(false);
    setShowConfirmModal(false);
    setUsarOrdenAutomatico(false);
    setShowRotateImageModal(false);
    setImagenesCategorias([]);
    setContenidosDinamicos([]);
    setOpcionesRotacion([]);
    setOpenMenuIndex(null);
    setUltimaActualizacion("");
    setCurrentVideoIndex(0);
  };

  const borrarImagenesSeleccionadas = async () => {
    const selectedRows = getSelectedRows();
    if (selectedRows.length === 0) {
      return;
    }

    try {
      setShowLoader(true);
      await borrarImagenes(
        API_URL,
        selectedRows.map((imagen) => imagen.id)
      );
      setImagenes(imagenes.filter((imagen) => !selectedRows.includes(imagen)));
      setShowLoader(false);
      notify("Imagenes borradas con éxito");
    } catch (error) {
      setShowLoader(false);
    }
  };

  const borrarImagen = async () => {
    try {
      setShowLoader(true);
      const id = selectedId;
      await deleteImage(API_URL, id);
      setImagenes(imagenes.filter((imagen) => imagen.id !== id));
      setSelectedId(null);
      setShowLoader(false);
      notify("Imagen borrada con éxito");
    } catch (error) {
      setShowLoader(false);
    }
  };

  const cambiarImagen = async (
    file,
    editCategoria = false,
    comentario = null
  ) => {
    if (!file) {
      notify("Por favor, selecciona una imagen válida.");
      return;
    }
    try {
      setShowLoader(true);
      const id = selectedId;
      await updateImage(API_URL, id, file);
      if (editCategoria && comentario) {
        await cambiarComentariosImagenesSeleccion(
          API_URL,
          [
            {
              ...imagenes.find((imagen) => imagen.id === id),
            },
          ],
          comentario.id
        );
      }
      const resImagenes = await fetchImagenes(
        API_URL,
        selectedContenidoDinamico?.id
      );
      setImagenes(resImagenes || []);
      setSelectedId(null);
      setShowLoader(false);
      notify("Imagen actualizada con éxito");
    } catch (error) {
      setShowLoader(false);
    }
  };

  const rotarImagenesSeleccionadas = async (rotacionImagen) => {
    const selectedRows = getSelectedRows();
    if (selectedRows.length === 0) {
      return;
    }

    try {
      setShowLoader(true);
      await rotacionImagenes(
        API_URL,
        selectedRows.map((imagen) => imagen.id),
        rotacionImagen
      );
      const resImagenes = await fetchImagenes(
        API_URL,
        selectedContenidoDinamico?.id
      );
      setImagenes(resImagenes || []);
      setShowLoader(false);
      notify("Imagenes rotadas con éxito");
    } catch (error) {
      setShowLoader(false);
    }
  };

  const rotarImagenActual = async () => {
    let grados = rotation % 360;
    if (grados === 0) {
      return;
    }
    if (grados < 0) {
      grados = 360 + grados;
    }

    try {
      setShowLoader(true);
      const id = imagenes[selectedCarouselIndex].id;
      await rotacionImagenes(
        API_URL,
        [id],
        opcionesRotacion.find((opcion) => opcion.grados == grados)
      );
      const resImagenes = await fetchImagenes(
        API_URL,
        selectedContenidoDinamico?.id
      );
      setImagenes(resImagenes || []);
      resetRotation();
      setShowLoader(false);
      notify("Imagen rotada con éxito");
    } catch (error) {
      setShowLoader(false);
    }
  };

  const handleDownloadAllImages = async () => {
    try {
      setShowLoader(true);
      const response = await generarZipImagenesContenidoDinamico(
        API_URL,
        selectedContenidoDinamico.id
      );

      const blob = new Blob([response], {
        type: "application/zip",
      });

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `imagenes_${selectedContenidoDinamico.id}.zip`;
      setShowLoader(false);
      link.click();
      URL.revokeObjectURL(url);
      notify("Imagenes descargadas con éxito");
    } catch (error) {
      setShowLoader(false);
    }
  };

  const handleGenerarZipImagenes = async () => {
    try {
      setShowLoader(true);
      const response = await generarZipImagenes(API_URL, trabajoId);

      const blob = new Blob([response], {
        type: "application/zip",
      });

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `imagenestrabajo${trabajoId}.zip`;
      setShowLoader(false);
      link.click();
      URL.revokeObjectURL(url);
      notify("Imagenes descargadas con éxito");
    } catch (error) {
      setShowLoader(false);
    }
  };

  const handleGenerarIDsImagenes = async () => {
    const numbers = imagenes.map((imagen) => imagen.id);
    const csvContent = numbers.join(",\n");

    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "ids.csv";
    link.click();

    URL.revokeObjectURL(url);
  };

  const handleNextImage = async (prev = false) => {
    const currentIndex = imagenes.findIndex(
      (imagen) => imagen.id === selectedId
    );

    const nextIndex = prev
      ? (currentIndex - 1 + imagenes.length) % imagenes.length
      : (currentIndex + 1) % imagenes.length;

    const img = imagenes[nextIndex];

    setSelectedId(img.id);

    const url = `${API_URL}/${img.link.split(pathToSplit)[1]}`;
    const queryParams = url.split("?")[1];

    const { buffer, contentType, filename } = await fetchImage(
      API_URL,
      queryParams
    );

    const type = contentType === "image/jpg" ? "image/jpeg" : contentType;
    const blob = new Blob([buffer], { type });
    const file = new File([blob], filename, { type });
    editorRef.current?.handleNext(file, img);
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={false}
        onClose={cerrarYLimpiarTodo}
        open={showModal}
        disableEnforceFocus
      >
        <Snackbar
          open={showSnackbar}
          autoHideDuration={3000}
          onClose={() => {
            setShowSnackbar(false);
            setSnackbarMessage("");
          }}
          message={snackbarMessage}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          slotProps={{
            content: {
              sx: {
                backgroundColor: "white",
                color: "#222",
                justifyContent: "center",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "16px",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            },
          }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            height: "80vh",
          }}
        >
          <Box sx={{ width: "100%" }}>
            <Box
              sx={{
                height: "50px",
                padding: "20px",
              }}
            >
              <Typography sx={{ fontSize: "18px" }} align="left">
                Multimedia - {trabajoName}
              </Typography>
              <IconButton
                aria-label="close"
                onClick={handleCloseModal}
                sx={(theme) => ({
                  position: "absolute",
                  right: 0,
                  top: 6,
                  color: theme.palette.grey[500],
                })}
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <Box
              sx={{
                height: "50px",
                padding: "20px",
                display: "flex",
                gap: "20px",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              {/* {trackerData && trackerData.etapa === 6 && (
                <Chip
                  onClick={() => {
                    setOpenStepperModal(true);
                  }}
                  label="Acciones"
                  icon={<Link />}
                />
              )} */}

              {selectedType === 1 && (
                <>
                  <Chip
                    onClick={() => handleGenerarZipImagenes()}
                    label="Descargar Imágenes"
                    icon={<DownloadIcon />}
                  />
                  <Chip
                    onClick={() => handleGenerarIDsImagenes()}
                    label="Descargar IDs"
                    icon={<DownloadIcon />}
                  />
                </>
              )}

              {/* <Chip onClick={() => {}} label="Copiar URL" icon={<Link />} /> */}
              <Typography sx={{ fontSize: "16px", color: "grey" }}>
                Última modificación: {ultimaActualizacion}
              </Typography>
            </Box>
            <Box
              sx={{
                borderBottom: 1,
                borderColor: "divider",
              }}
            >
              <Tabs
                variant="fullWidth"
                value={selectedType}
                onChange={(e, value) => setSelectedType(value)}
              >
                <Tab label="Imágenes" value={1} />
                <Tab label="Documentos" value={2} />
                <Tab label="Videos" value={3} />
              </Tabs>
              {selectedType !== 2 && contenidosDinamicos.length > 0 && (
                <Tabs
                  variant="fullWidth"
                  value={selectedContenidoDinamico?.id || null}
                  onChange={(e, value) =>
                    setSelectedContenidoDinamico(
                      contenidosDinamicos.find((c) => c.id === value)
                    )
                  }
                >
                  {contenidosDinamicos.length > 0 &&
                    contenidosDinamicos.map((contenido) => (
                      <Tab
                        label={contenido.descripcion}
                        value={contenido.id}
                        key={contenido.id}
                      />
                    ))}
                </Tabs>
              )}
            </Box>
            {selectedType === 1 && (
              <Box sx={{ padding: "20px" }}>
                {/* <ImageDropAndEdit
                  cambiarImagen={cambiarImagen}
                  ref={editorRef}
                  onUpload={subirImagen}
                  imagenesCategorias={imagenesCategorias}
                /> */}
                <ImageEditor
                  cambiarImagen={cambiarImagen}
                  onUpload={subirImagen}
                  imagenesCategorias={imagenesCategorias}
                  ref={editorRef}
                  handleNextImage={handleNextImage}
                  subirMultiplesImagenes={subirMultiplesImagenes}
                />

                <Stack
                  direction="row"
                  spacing={2}
                  sx={{
                    flexWrap: "wrap",
                    p: 2,
                    justifyContent: "space-between",
                    rowGap: "8px",
                  }}
                >
                  {/* <Alert
                    severity="info"
                    variant="outlined"
                    sx={{ width: "100%" }}
                  >
                    ¡Para acciones en conjunto, selecciona una o más fotos!
                  </Alert> */}
                  <FormGroup sx={{ height: "min-content", textWrap: "nowrap" }}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={usarOrdenAutomatico}
                          onChange={(e) => {
                            setShowOrdenModal(e);
                          }}
                        />
                      }
                      label="Ordenamiento automático"
                    />
                  </FormGroup>
                  <>
                    <Button
                      sx={{
                        textTransform: "none",
                        height: "min-content",
                        px: "16px",
                        py: "8px",
                        textWrap: "nowrap",
                        backgroundColor: "#223d51",
                        color: "#ffffff",
                      }}
                      startIcon={
                        <img
                          src={Comentarios}
                          alt="Comentarios"
                          width={14}
                          height={12}
                        />
                      }
                      onClick={() => openCategoriaModal()}
                    >
                      Cambiar comentarios
                    </Button>
                    <Button
                      sx={{
                        textTransform: "none",
                        height: "min-content",
                        px: "16px",
                        py: "8px",
                        textWrap: "nowrap",
                        backgroundColor: "#223d51",
                        color: "#ffffff",
                      }}
                      startIcon={
                        <img
                          src={DescargarBlanco}
                          alt="Descargar"
                          width={14}
                          height={12}
                        />
                      }
                      onClick={() => handleDownloadAllImages()}
                    >
                      Descargar imágenes
                    </Button>
                    <Button
                      sx={{
                        textTransform: "none",
                        height: "min-content",
                        px: "16px",
                        py: "8px",
                        textWrap: "nowrap",
                        backgroundColor: "#223d51",
                        color: "#ffffff",
                      }}
                      variant="contained"
                      color="error"
                      startIcon={
                        <img
                          src={EliminarBlanco}
                          alt="Eliminar"
                          width={14}
                          height={12}
                        />
                      }
                      onClick={() => {
                        if (getSelectedRows().length === 0) return;
                        setShowConfirmModal(true);
                        setConfirmModalType("delete");
                      }}
                    >
                      Borrar imágenes
                    </Button>
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#223d51",
                        color: "#ffffff",
                        textTransform: "none",
                        height: "min-content",
                        px: "16px",
                        py: "8px",
                        textWrap: "nowrap",
                      }}
                      startIcon={<RotateRightIcon width={14} height={12} />}
                      onClick={() => {
                        if (getSelectedRows().length === 0) return;
                        setShowRotateImageModal(true);
                      }}
                    >
                      Rotar imágenes
                    </Button>
                    <Button
                      variant="contained"
                      sx={{
                        textTransform: "none",
                        height: "min-content",
                        px: "16px",
                        py: "8px",
                        backgroundColor: "#4caf50",
                        color: "#ffffff",
                      }}
                      onClick={() => guardarCambios()}
                    >
                      Guardar
                    </Button>
                  </>
                </Stack>
                {imagenes.length > 0 ? (
                  <Paper sx={{ width: "100%" }}>
                    <MaterialReactTable table={table} />
                  </Paper>
                ) : (
                  <Typography variant="body1">Sin imágenes</Typography>
                )}
              </Box>
            )}
            {selectedType === 2 && (
              <DocumentosTab
                API_URL={API_URL}
                trabajoId={trabajoId}
                setGlobalLoading={setShowLoader}
                notify={notify}
              />
            )}
            {selectedType === 3 && (
              <Box sx={{ padding: "20px" }}>
                <Dropzone
                  multiple={true}
                  accept={{ "video/mp4": [".mp4"] }}
                  onDrop={(acceptedFiles) => {
                    if (!acceptedFiles || acceptedFiles.length === 0) return;
                    if (acceptedFiles.length === 1) {
                      handleUploadVideo(acceptedFiles[0]);
                    } else {
                      handleUploadMultipleVideos(acceptedFiles);
                    }
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <section
                      style={{
                        border: "2px dashed #999",
                        borderRadius: "8px",
                        textAlign: "center",
                        backgroundColor: "#f9f9f9",
                        color: "#666",
                        fontSize: "16px",
                        cursor: "pointer",
                        transition: "background-color 0.3s, border-color 0.3s",
                      }}
                    >
                      <div {...getRootProps()} style={{ padding: "40px" }}>
                        <input {...getInputProps()} />
                        <p>Videos MP4</p>
                        <p>{"(Seleccionar o arrastrar archivo)"}</p>
                      </div>
                    </section>
                  )}
                </Dropzone>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "20px",
                  }}
                >
                  <Button
                    color="info"
                    variant="outlined"
                    sx={{
                      textTransform: "none",
                    }}
                    onClick={fetchTotalVideos}
                  >
                    Cargar videos sin fase relacionada
                  </Button>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "20px 0",
                  }}
                >
                  <div
                    style={{
                      width: "800px",
                      position: "relative",
                    }}
                  >
                    <Carousel
                      ref={carouselRef}
                      swipeable={false}
                      draggable={false}
                      responsive={{
                        desktop: {
                          breakpoint: { max: 3000, min: 0 },
                          items: 1,
                          slidesToSlide: 1,
                        },
                      }}
                      showDots
                      customDot={<CustomDot />}
                      containerClass="carousel-container"
                      customButtonGroup={<ButtonGroup />}
                      beforeChange={() => {
                        Object.values(videoRefs.current).forEach((ref) => {
                          if (ref?.current && !ref.current.paused) {
                            ref.current.pause();
                          }
                        });
                      }}
                      afterChange={(previousSlide, { currentSlide }) => {
                        setCurrentVideoIndex(currentSlide);
                      }}
                    >
                      {videos.map((video, index) => (
                        <div
                          key={video.id}
                          style={{
                            width: "100%",
                            height: "450px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#000",
                          }}
                        >
                          <video
                            ref={videoRefs.current[video.id]}
                            style={{
                              maxWidth: "100%",
                              maxHeight: "100%",
                              width: "auto",
                              height: "auto",
                              objectFit: "contain",
                            }}
                            src={`${API_URL}/api/descargar-videos-trabajo/${video.id}`}
                            controls
                            type="video/mp4"
                            poster={`${API_URL}/api/video/thumb/${video.id}`}
                          />
                        </div>
                      ))}
                    </Carousel>
                  </div>
                </div>
              </Box>
            )}
          </Box>
        </div>
      </Dialog>
      <Dialog
        open={showCategoriaModal}
        onClose={() => setShowCategoriaModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div style={{ padding: "20px" }}>
          <h2>Seleccionar categoría</h2>{" "}
          <h2> (Este comentario se asignará a todas las selecciones)</h2>
          <select
            id="category-select"
            style={{
              border: "1px solid #ccc",
              borderRadius: "4px",
              fontSize: "16px",
              width: "100%",
              color: "#555",
              height: "50px",
            }}
            placeholder="Selecciona un comentario..."
          >
            {imagenesCategorias.map((categoria) => (
              <option key={categoria.id} value={categoria.id}>
                {categoria.nombre}
              </option>
            ))}
          </select>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
              gap: "8px",
            }}
          >
            <Button
              variant="contained"
              color="inherit"
              onClick={() => setShowCategoriaModal(false)}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                const categoriaId =
                  document.getElementById("category-select").value;
                setShowCategoriaModal(false);
                cambiarComentariosPorSeleccion(categoriaId);
              }}
            >
              Guardar
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog
        open={showRotateImageModal}
        onClose={() => setShowRotateImageModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div style={{ padding: "20px" }}>
          <h2>Rotar imágenes por seleccion</h2>

          <select
            id="rotate-select"
            style={{
              border: "1px solid #ccc",
              borderRadius: "4px",
              fontSize: "16px",
              width: "100%",
              color: "#555",
              height: "50px",
            }}
            placeholder="Seleccionar grados..."
          >
            {opcionesRotacion.map((opcion) => (
              <option key={opcion.grados} value={opcion.grados}>
                {opcion.lenguaje}
              </option>
            ))}
          </select>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
              gap: "8px",
            }}
          >
            <Button
              variant="contained"
              color="inherit"
              onClick={() => setShowRotateImageModal(false)}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                const rotacion = document.getElementById("rotate-select").value;
                const rotacionImagen = opcionesRotacion.find(
                  (opcion) => opcion.grados == rotacion
                );
                setShowRotateImageModal(false);
                rotarImagenesSeleccionadas(rotacionImagen);
              }}
            >
              Guardar
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog
        open={showOrdenModal}
        onClose={() => setShowOrdenModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div style={{ padding: "20px" }}>
          <h2>
            {usarOrdenAutomatico
              ? "Desactivar ordenamiento automático"
              : "Activar ordenamiento automático"}
          </h2>
          {usarOrdenAutomatico && (
            <p>
              Después de guardar, las imágenes ya existentes serán ordenadas. El
              ordenamiento manual será ignorado.
            </p>
          )}

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
              gap: "8px",
            }}
          >
            <Button
              variant="contained"
              color="inherit"
              onClick={() => setShowOrdenModal(false)}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setShowOrdenModal(false);
                handleCambiarOrdenamiento();
              }}
            >
              Guardar
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog
        open={showEditModal}
        onClose={() => setShowEditModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <IconButton
          aria-label="close"
          onClick={() => setShowEditModal(false)}
          sx={(theme) => ({
            position: "absolute",
            right: 0,
            top: 6,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <div style={{ padding: "20px", width: "600px" }}>
          <h2>Cambiar Imagen</h2>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              marginTop: "20px",
              gap: "8px",
            }}
          >
            <Dropzone
              accept={{
                "image/jpeg": [".jpg", ".jpeg"],
                "image/png": [".png"],
              }}
              onDrop={(acceptedFiles) => {
                cambiarImagen(acceptedFiles[0]);
                setShowEditModal(false);
              }}
            >
              {({ getRootProps, getInputProps }) => (
                <section
                  style={{
                    border: "2px dashed #999",
                    borderRadius: "8px",
                    textAlign: "center",
                    backgroundColor: "#f9f9f9",
                    color: "#666",
                    fontSize: "16px",
                    cursor: "pointer",
                    transition: "background-color 0.3s, border-color 0.3s",
                  }}
                >
                  <div {...getRootProps()} style={{ padding: "40px" }}>
                    <input {...getInputProps()} />
                    <p>Cambiar Imagen</p>
                    <p>{"(Seleccionar o arrastrar archivo)"}</p>
                  </div>
                </section>
              )}
            </Dropzone>
          </div>
        </div>
      </Dialog>
      <Dialog
        open={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div style={{ padding: "20px" }}>
          <h2>Confirmación</h2>

          <p>
            {confirmModalType === "delete"
              ? "¿Seguro que desea borrar las imágenes?"
              : confirmModalType === "deleteOne"
              ? "¿Seguro que desea borrar la imagen?"
              : confirmModalType === "deleteFile"
              ? "¿Seguro que desea borrar este documento?"
              : confirmModalType === "deleteVideo"
              ? "¿Seguro que desea borrar este video?"
              : "Guardar cambios"}
          </p>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
              gap: "8px",
            }}
          >
            <CustomButton
              background="#FFFFFF"
              color="#000000"
              text="Cancelar"
              width="140px"
              height="40px"
              fontWeight="700"
              fontSize="14px"
              border="1px solid #D9D9D9"
              type="button"
              onClick={() => setShowConfirmModal(false)}
            />

            <CustomButton
              background="#223D51" // similar a variant="contained" color="primary"
              color="#FFFFFF"
              text="Aceptar"
              width="140px"
              height="40px"
              fontWeight="700"
              fontSize="14px"
              border="none"
              type="button"
              hoverShadow="0 4px 12px rgba(0,0,0,0.2)" // opcional
              onClick={() => {
                setShowConfirmModal(false);
                if (confirmModalType === "delete") {
                  borrarImagenesSeleccionadas();
                } else if (confirmModalType === "deleteOne") {
                  borrarImagen();
                } else if (confirmModalType === "deleteFile") {
                  // handleDeleteDocument();
                } else if (confirmModalType === "deleteVideo") {
                  handleDeleteVideo();
                }
              }}
            />
          </div>
        </div>
      </Dialog>
      <Dialog
        open={showRotateImageCarousel}
        onClose={() => handleRotationModalClose()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        transitionDuration={0}
      >
        <IconButton
          aria-label="close"
          onClick={() => handleRotationModalClose()}
          sx={(theme) => ({
            position: "absolute",
            right: 0,
            top: 6,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <div style={{ padding: "20px 40px" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "500px",
              height: "min-content",
              gap: "20px",
            }}
          >
            <div className="embla" ref={emblaRef}>
              <div className="embla__container">
                {imagenes.map((imagen, index) => (
                  <div className="embla__slide" key={imagen.id}>
                    <img
                      style={{
                        width: "500px",
                        height: "500px",
                        objectFit: "contain",
                        transform: `rotate(${
                          selectedCarouselIndex === index ? rotation : 0
                        }deg)`,
                      }}
                      src={`${API_URL}/${imagen.link.split(pathToSplit)[1]}`}
                      alt="imagen"
                    />
                  </div>
                ))}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                padding: "0 10px",
              }}
            >
              <Button
                variant="outlined"
                className="embla__prev"
                onClick={scrollPrev}
              >
                <ArrowBackIosIcon />
              </Button>

              <Button variant="outlined" onClick={() => rotate(-90)}>
                <Rotate90DegreesCcwIcon />
              </Button>
              <Button variant="outlined" onClick={() => rotate(90)}>
                <Rotate90DegreesCwIcon />
              </Button>
              <p
                style={{
                  margin: "0",
                  whiteSpace: "nowrap",
                  pointerEvents: "none",
                }}
              >
                {selectedCarouselIndex + 1} de {imagenes.length}
              </p>
              <Button variant="outlined" onClick={resetRotation}>
                <RestoreIcon />
              </Button>

              <Button variant="outlined" onClick={rotarImagenActual}>
                <SaveIcon />
              </Button>

              <Button
                variant="outlined"
                className="embla__next"
                onClick={scrollNext}
              >
                <ArrowForwardIosIcon />
              </Button>
            </div>
          </div>
        </div>
      </Dialog>
      <LoaderDialog open={showLoader} />
      {/* <StepperModal
        onClose={() => setOpenStepperModal(false)}
        open={openStepperModal}
        title={"Validación PM"}
        onConfirm={handleUpdateEvent}
      /> */}
    </>
  );
};
